import { Link } from 'react-router-dom';
import { Car, FileText, IdCard, Plane, Stethoscope } from 'lucide-react';
import { Headline } from '../../atoms';
import { Header } from '../../organisms';

const documentsData = [
  {
    route: '/id-card',
    name: 'Patientenausweis',
    description:
      'Weist Sie als Cannabis-Patient aus und dient als zusätzlicher Nachweis zum Rezept. Gültigkeit: 1 Jahr.',
    icon: <IdCard size={24} />,
    price: 15,
  },
  {
    route: '/schengen-certificate',
    name: 'Schengenbescheinigung',
    description:
      'Erlaubt die Mitnahme Ihrer Medikation auf Reisen (max. 30 Tage) im Schengenraum. Bitte mind. 2 Wochen vorab bestellen.',
    icon: <Plane size={24} />,
    price: 35,
  },
  {
    route: '/medical-certificate',
    name: 'Ärztliches Attest',
    description: 'Ein Kurzattest für verschiedene Verwendungszwecke.',
    icon: <Stethoscope size={24} />,
    price: 19,
  },
  {
    route: '/vehicle-certificate',
    name: 'Bescheinigung zum Führen eines Fahrzeugs',
    description: 'Bescheinigt Ihre Fahrtüchtigkeit unter Medikation. Gültigkeit: 3 Monate.',
    icon: <Car size={24} />,
    price: 19,
  },
  {
    route: '/medical-report',
    name: 'Ausführliches ärztliches Gutachten',
    description: 'z.B. für Vorlage bei der Führerscheinstelle oder bei der privaten Krankenkasse.',
    icon: <FileText size={24} />,
    price: 100,
  },
];

export function Certificates() {
  return (
    <>
      <Header />

      <div className='flex flex-col'>
        <div className='w-full max-w-xl mx-auto my-5 mb-16'>
          <div className='text-center px-4'>
            <Headline level={3} className='mb-5'>
              Bescheinigungen
            </Headline>
          </div>

          <div className='mt-9 flex flex-col gap-4'>
            {documentsData.map((doc) => (
              <Link
                key={doc.name}
                to={doc.route}
                className='block p-4 border rounded-lg no-underline hover:no-underline hover:bg-gray-50 hover:border-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all'
              >
                <div className='flex flex-col gap-4'>
                  <div className='flex items-start gap-4'>
                    <span className='text-primary pt-1'>{doc.icon}</span>
                    <div>
                      <h4 className='font-semibold text-gray-800 my-0'>{doc.name}</h4>
                      <p className='text-sm text-gray-600 mt-1'>{doc.description}</p>
                      <div className='flex gap-2'>
                        <span className='text-base font-semibold text-gray-800'>{doc.price.toFixed(2)} €</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
